import React, { useContext, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Typography, theme, Spin, Form, Upload, Grid, Flex } from 'antd';
import { InboxOutlined, PaperClipOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import _ from 'lodash';

import { MessageContext } from '../../../layouts/NavigationLayout';

//Helpers
import GeneralHelper from '../../../helpers/general';
import AssetHelper from '../../../helpers/asset';

//Components
import CustomFileUpload from '../../../components/CustomFileUpload';
import Confirmation from '../../../components/Confirmation';
import ButtonGroupComponent from './ButtonGroupComponent';

const { Title, Text } = Typography;
const { Item } = Form;
const { useToken } = theme;
const { Dragger } = Upload;
const { useBreakpoint } = Grid;

const SupportingDocumentsView = (props) => {

	const [nextDisabled, setNextDisabled] = useState(true);
	const [draftDisabled, setDraftDisabled] = useState(true);
	const [isNext, setIsNext] = useState(false);
	const [torFileList, setTorFileList] = useState([]);
	const [otherFileList, setOtherFileList] = useState([]);
	const [cvFile, setCvFile] = useState(null);
	const [gradingFile, setGradingFile] = useState(null);
	const [englishProfFile, setEnglishProfFile] = useState(null);
	const [isInitialLoad, setIsInitialLoad] = useState(true);
	const [confirmation, setConfirmation] = useState(false);
	const [incompleteFields, setIncompleteFields] = useState(false);
	const [warning, setWarning] = useState(false);

	const history = useHistory();
	const formRef = useRef(null);
	const { token } = useToken();
	const screens = useBreakpoint();
	const messageApi = useContext(MessageContext);

	const assetActionUrl = AssetHelper.getActionUrl();
	const assetHeader = AssetHelper.getHeader();

	const query = GeneralHelper.getParamsFromUrl();

	const { colorPrimary, colorLink, colorNeutral } = token;

	const {
		documentPageProps,
		personalParticularPageProps,
		getDocument,
		onDocumentSubmit,
		resetDocumentPage,
		getApplication,
		getPersonalParticularByApplicationId,
		resetDocumentMeta,
		reviewAndSubmissionPageProps,
		setHasUnsavedChanges,
		refereeInfoPageProps,
		resetRefereeInfoMeta
	} = props;
	const { document, loading, loadingSubmit, meta } = documentPageProps || {};
	const { personalInfo, loading: loadingPersonalInfo } = personalParticularPageProps;
	const fileNameLimit = screens.xs ? 10 : 30;
	const { application } = reviewAndSubmissionPageProps;
	const { meta: refereeInfoMeta } = refereeInfoPageProps;
	const currentStep = _.get(application, 'current_step');
	const displayId = _.get(application, 'display_id');

	const {
		cv_asset_id,
		grading_system_asset_id,
		english_proficiency_asset_id,
		transcript_of_records,
		other_documents,
		cvAsset,
		englishProfAsset,
		gradingAsset
	} = document || {};

	useEffect(() => {
		query.application_id && getDocument(query.application_id);
		query.application_id && getPersonalParticularByApplicationId(query.application_id);
		return () => {
			resetDocumentPage();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (document) {
			handleInitialValues();
		} else {
			setDraftDisabled(true);
			setHasUnsavedChanges(false);
			setNextDisabled(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [document]);

	useEffect(() => {
		if (incompleteFields && isInitialLoad === false) {
			setWarning(true);
		} else {
			setWarning(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [incompleteFields]);

	useEffect(() => {
		checkFormValues();
		// isInitialLoad === false && handleOnChange();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [incompleteFields, cvFile, gradingFile, englishProfFile, torFileList, otherFileList]);

	useEffect(() => {
		if (meta) {
			if (meta.code === 200) {
				setDraftDisabled(true);
				setHasUnsavedChanges(false);
				setIsInitialLoad(true);
				setIncompleteFields(false);
				setWarning(false);
				!isNext && isInitialLoad === false && messageApi.open({
					type: 'success',
					content: `${meta.message}`,
					duration: 2.5
				});
				if (isNext) {
					if (currentStep === 6) {
						window.location.href = process.env.NODE_ENV === 'development'
							? `/application?step=6&application_id=${query.application_id}`
							: `/summercamp/app/application?step=6&application_id=${query.application_id}`;
					} else {
						history.push(`/application?step=5&application_id=${query.application_id}`);
					}
				}
				!isNext && !nextDisabled && query.application_id && getApplication(query.application_id);
			} else {
				messageApi.open({
					type: 'error',
					content: `${meta.message}`,
					duration: 2.5
				});
			}
		}
		return () => {
			resetDocumentMeta();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	useEffect(() => {
		if (refereeInfoMeta) {
			if (refereeInfoMeta.code === 200) {
				messageApi.open({
					type: 'success',
					content: `${refereeInfoMeta.message}`,
					duration: 2.5
				});
			} else {
				messageApi.open({
					type: 'error',
					content: `${refereeInfoMeta.message}`,
					duration: 2.5
				});
			}
		}
		return () => {
			resetRefereeInfoMeta();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refereeInfoMeta]);

	//Start of Functions

	const handleInitialValues = () => {
		let torFiles = [];
		let otherFiles = [];
		if (!_.isEmpty(transcript_of_records)) {
			// eslint-disable-next-line array-callback-return
			transcript_of_records.map(tor => {
				tor.asset && torFiles.push({
					uid: tor.asset_id,
					asset_id: tor.asset_id,
					url: AssetHelper.getDownloadUrl(tor.asset_id),
					name: tor.asset.file_name,
					dl_file_name: tor.asset.dl_file_name,
					status: 'done'
				});
			});
		}
		if (!_.isEmpty(other_documents)) {
			// eslint-disable-next-line array-callback-return
			other_documents.map(doc => {
				doc.asset && otherFiles.push({
					uid: doc.asset_id,
					asset_id: doc.asset_id,
					url: AssetHelper.getDownloadUrl(doc.asset_id),
					name: doc.asset.file_name,
					dl_file_name: doc.asset.dl_file_name,
					status: 'done'
				});
			});
		}
		if (cvAsset) {
			setCvFile({
				asset_id: cv_asset_id,
				name: cvAsset.file_name,
				status: 'done'
			});
		}
		if (gradingAsset) {
			setGradingFile({
				asset_id: grading_system_asset_id,
				name: gradingAsset.file_name,
				status: 'done'
			});
		}
		if (englishProfAsset) {
			setEnglishProfFile({
				asset_id: english_proficiency_asset_id,
				name: englishProfAsset.file_name,
				status: 'done'
			});
		}
		!_.isEmpty(torFiles) && setTorFileList(torFiles);
		!_.isEmpty(otherFiles) && setOtherFileList(otherFiles);
	};

	const onNext = () => {
		setIsNext(true);
	};

	const checkFormValues = () => {
		if (!document && isInitialLoad && incompleteFields) {
			return;
		}

		if (
			!_.isNil(cvFile) &&
			cvFile.status !== 'uploading' &&
			!_.isEmpty(torFileList) &&
			!_.some(torFileList, { status: 'uploading' }) &&
			!_.isNil(gradingFile) &&
			gradingFile.status !== 'uploading' &&
			!_.isNil(englishProfFile) &&
			englishProfFile.status !== 'uploading' &&
			(
				(!_.isEmpty(otherFileList) || _.isEmpty(otherFileList)) &&
				!_.some(otherFileList, { status: 'uploading' })
			)
		) {
			setNextDisabled(false);
		} else {
			setNextDisabled(true);
		}

		if (
			(cvFile && cvFile.status !== 'uploading') ||
			(gradingFile && gradingFile.status !== 'uploading') ||
			(englishProfFile && englishProfFile.status !== 'uploading') ||
			(!_.isEmpty(torFileList) && !_.some(torFileList, { status: 'uploading' })) ||
			(!_.isEmpty(otherFileList) && !_.some(otherFileList, { status: 'uploading' }))
		) {
			if (isInitialLoad) {
				setDraftDisabled(true);
				setHasUnsavedChanges(false);
			} else {
				setDraftDisabled(false);
				setHasUnsavedChanges(true);
			}
		} else {
			setDraftDisabled(true);
			setHasUnsavedChanges(false);
		}

		if (
			!_.isEmpty(torFileList) ||
			!_.isNil(cvFile) ||
			!_.isNil(gradingFile) ||
			!_.isNil(englishProfFile) ||
			!_.isEmpty(otherFileList)
		) {
			setIncompleteFields(false);
		} else {
			setIncompleteFields(true);
		}
	};

	const getFileIconColor = (status) => {
		const statusColor = status === 'error' ? '#ff4d4f' : (status === 'done' ? '#8c8c8c' : colorNeutral);
		return statusColor;
	};

	const getFileNameColor = (status) => {
		const statusColor = status === 'error' ? '#ff4d4f' : (status === 'done' ? colorLink : colorNeutral);
		return statusColor;
	};

	const getLastFileNameSuffix = (fileList) => {
		let lastFileSuffix = 0;
		if (fileList.length === 0) {
			return lastFileSuffix;
		}

		// Extract suffix numbers from existing files
		const suffixNumbers = fileList.map(file => {
			// Get the dl_file_name from file
			let dlFileName = file.dl_file_name;

			// Extract the suffix number from patterns like "Others1.pdf", "Transcript_Cert1.pdf", etc.
			const match = dlFileName.match(/Others(\d+)\.pdf$/) || dlFileName.match(/Transcript_Cert(\d+)\.pdf$/);
			return match ? parseInt(match[1], 10) : 0;
		}).filter(num => num > 0); // Filter out 0s (files that don't match the pattern)

		// If no existing files with suffix, start from 0
		if (suffixNumbers.length === 0) {
			return 0;
		}

		// Return the highest suffix number found
		return Math.max(...suffixNumbers);
	};

	const customItemRender = (originNode, file, fileList, field) => {
		return (
			<Row justify="space-between">
				<Col align="start">
					{file.status === 'done' || file.status === 'error' ?
						<PaperClipOutlined style={{ color: getFileIconColor(file.status), marginRight: 6 }} />
						:
						<LoadingOutlined
							style={{ marginRight: 6, color: '#8c8c8c', fontSize: 16 }}
							spin
						/>
					}
					{file.status === 'done' ?
						<a
							href={AssetHelper.getDownloadUrl(file.asset_id)}
							target="_blank"
							style={{ color: getFileNameColor(file.status) }}
							rel="noreferrer"
						>{GeneralHelper.truncateFileName(file.name, fileNameLimit, 'pdf')}
						</a>
						:
						<Text style={{ color: getFileNameColor(file.status) }}>
							{GeneralHelper.truncateFileName(file.name, fileNameLimit, 'pdf')}
						</Text>
					}
				</Col>
				<Col align="end">
					<DeleteOutlined
						onClick={() => {
							field === 'tor' && setTorFileList(torFileList.filter(torFile => torFile.asset_id !== file.asset_id));
							field === 'other' && setOtherFileList(otherFileList.filter(otherFile => otherFile.asset_id !== file.asset_id));
							setIsInitialLoad(false);
						}}
						style={{ cursor: 'pointer', color: getFileIconColor(file.status) }}
					/>
				</Col>
			</Row>
		);
	};

	//End of Functions

	if (loading || loadingPersonalInfo) {
		return (
			<div
				style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
			>
				<Spin />
			</div>
		);
	}

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
			<Row>
				<Form
					ref={formRef}
					layout="vertical"
					onFinish={() => {
						const fields = {
							application_id: query.application_id,
							save_method: nextDisabled ? 'draft_save' : 'final_save',
							transcript_of_records: !_.isEmpty(torFileList) ? torFileList.map(tor => tor.asset_id) : [],
							other_documents: !_.isEmpty(otherFileList) ? otherFileList.map(tor => tor.asset_id) : []
						};

						if (cvFile) fields.cv_asset_id = cvFile.asset_id;
						if (gradingFile) fields.grading_system_asset_id = gradingFile.asset_id;
						if (englishProfFile) fields.english_proficiency_asset_id = englishProfFile.asset_id;

						if (document) {
							fields.updated_at = document.updated_at;
							onDocumentSubmit({ id: document._id, fields });
						} else {
							onDocumentSubmit({ fields });
						}
					}}
				>
					<Title
						level={2}
						style={{ color: colorPrimary }}
					>Step 5</Title>
					<Item>
						<Row>
							<Text style={{ fontSize: 20, fontWeight: 510 }}>Supporting Documents</Text>
						</Row>
						<Row>
							<Text>Please upload the following supporting documents in PDF format (.pdf)</Text>
						</Row>
						{warning &&
							<Row>
								<Text type="warning">Note: Upload at least one file in order to save changes as draft</Text>
							</Row>
						}
					</Item>
					<Item
						label="Your Resume / CV"
						style={{ width: '100%', marginBottom: 20, padding: 0 }}
						required
					// help={isInitialLoad === false && _.isNil(cvFile) ? 'Your Resume / CV is required' : ''}
					// validateStatus={isInitialLoad === false && _.isNil(cvFile) ? 'error' : ''}
					>
						<CustomFileUpload
							attachment={cvFile}
							setAttachment={setCvFile}
							// style={{ borderColor: isInitialLoad === false && _.isNil(cvFile) ? 'red' : '#D4D4D4' }}
							style={{ borderColor: '#D4D4D4' }}
							messageApi={messageApi}
							// handleOnChange={handleOnChange}
							customFileName={personalInfo && displayId ? `${displayId}_${personalInfo.last_name}_${personalInfo.first_name}_CV.pdf` : ''}
							setIsInitialLoad={setIsInitialLoad}
						/>
					</Item>
					<Item
						label="Official Transcript(s) and/or Degree Certificate(s) (Max 5 files, Max 5MB each)"
						required
					// help={isInitialLoad === false && _.isEmpty(torFileList) ? 'Official Transcript(s) and/or Degree Certificate(s) is required' : ''}
					// validateStatus={isInitialLoad === false && _.isEmpty(torFileList) ? 'error' : ''}
					>
						<div
							style={{
								minWidth: screens.xxl || screens.xl || screens.lg || screens.md ? 500 : '100%',
								maxWidth: '100%',
								padding: 25,
								border: '1px solid',
								// borderColor: isInitialLoad === false && _.isEmpty(torFileList) ? 'red' : '#D9D9D9',
								borderColor: '#D4D4D4',
								borderRadius: 7
							}}
						>
							<Dragger
								name="file"
								accept=".pdf, .jpg, .jpeg"
								action={assetActionUrl}
								headers={assetHeader}
								fileList={torFileList}
								multiple={true}
								itemRender={(originNode, file, fileList) => customItemRender(originNode, file, fileList, 'tor')}
								beforeUpload={(file, fileList) => {
									const filename = file.name.split('.');
									const fileFormat = filename[filename.length - 1];
									// Check if the file size
									if (file.size > AssetHelper.getMaxSize()) {
										messageApi.open({
											type: 'error',
											content: `${file.name} ${AssetHelper.getMaxSizeMsg()}`,
											duration: 2.5
										});
										file.status = 'error';
										return false;
									}

									const maxNumOfFilesExceeded = !_.isEmpty(torFileList) ? (torFileList.length >= 5 || torFileList.length + fileList.length > 5) : fileList.length > 5;
									if (maxNumOfFilesExceeded) {
										messageApi.open({
											type: 'error',
											content: 'You can only upload up to five files.',
											duration: 2.5
										});
										file.status = 'error';
										return false;
									}


									const index = fileList.findIndex(f => f.uid === file.uid);
									const lastFileSuffix = getLastFileNameSuffix(torFileList);
									const suffix = lastFileSuffix + index + 1;
									// FIXME 
									const fileName = personalInfo && displayId ? `${file.name}&dl_file_name=${displayId}_${personalInfo.last_name}_${personalInfo.first_name}_Transcript_Cert${suffix}.${fileFormat || ''}` : file.name;
									const newFile = new File([file], fileName, { type: file.type });
									return newFile;
								}}
								onChange={info => {
									const { status } = info.file;
									const fileName = info.file.name.split('&dl_file_name')[0] || '';
									if (status === 'done') {
										messageApi.open({
											type: 'success',
											content: `${fileName} uploaded successfully.`,
											duration: 2.5
										});
									} else if (status === 'error') {
										messageApi.open({
											type: 'error',
											content: `${fileName} upload failed.`,
											duration: 2.5
										});
									}

									let fileList = [...info.fileList];
									fileList = fileList.map(file => {
										if (file.response) {
											file.url = AssetHelper.getDownloadUrl(file.response.data.asset._id);
											file.asset_id = file.response.data.asset._id;
											file.name = file.response.data.asset.file_name;
											file.dl_file_name = file.response.data.asset.dl_file_name;
										}
										return file;
									});

									setTorFileList(fileList.filter(file => file.status !== 'error'));
									setIsInitialLoad(false);
								}}
								style={{ width: '100%', padding: 10, marginBottom: 10 }}
							>
								<InboxOutlined style={{ fontSize: '5em', color: colorLink }} />
								<p style={{ margin: 0, fontSize: 14 }}>Click or drag file to this area to upload</p>
								<p style={{ margin: 0, fontSize: 10, color: '#6B6B6B' }}>
									Supports single or bulk upload. (PDF)
								</p>
							</Dragger>
						</div>
					</Item>
					<Item
						label="Grading System of Home Institution"
						required
					// help={isInitialLoad === false && _.isNil(gradingFile) ? 'Grading System of Home Institution is required' : ''}
					// validateStatus={isInitialLoad === false && _.isNil(gradingFile) ? 'error' : ''}
					>
						<CustomFileUpload
							attachment={gradingFile}
							setAttachment={setGradingFile}
							// style={{ borderColor: isInitialLoad === false && _.isNil(gradingFile) ? 'red' : '#D4D4D4' }}
							style={{ borderColor: '#D4D4D4' }}
							messageApi={messageApi}
							// handleOnChange={handleOnChange}
							customFileName={personalInfo && displayId ? `${displayId}_${personalInfo.last_name}_${personalInfo.first_name}_Grading.pdf` : ''}
							setIsInitialLoad={setIsInitialLoad}
						/>
					</Item>
					<Item
						label="Proof of English Proficiency"
						required
					// help={isInitialLoad === false && _.isNil(englishProfFile) ? 'Proof of English Proficiency is required' : ''}
					// validateStatus={isInitialLoad === false && _.isNil(englishProfFile) ? 'error' : ''}
					>
						<CustomFileUpload
							attachment={englishProfFile}
							setAttachment={setEnglishProfFile}
							// style={{ borderColor: isInitialLoad === false && _.isNil(englishProfFile) ? 'red' : '#D4D4D4' }}
							style={{ borderColor: '#D4D4D4' }}
							messageApi={messageApi}
							// handleOnChange={handleOnChange}
							customFileName={personalInfo && displayId ? `${displayId}_${personalInfo.last_name}_${personalInfo.first_name}_English.pdf` : ''}
							setIsInitialLoad={setIsInitialLoad}
						/>
					</Item>
					<Item
						label="Other Document(s) (Max 5 files, Max 5MB each)"
					>
						<div
							style={{
								minWidth: screens.xxl || screens.xl || screens.lg || screens.md ? 500 : '100%',
								maxWidth: '100%',
								padding: 25,
								border: '1px solid',
								borderColor: '#D9D9D9',
								borderRadius: 7
							}}
						>
							<Dragger
								name="file"
								accept=".pdf, .jpg, .jpeg"
								action={assetActionUrl}
								headers={assetHeader}
								itemRender={(originNode, file, fileList) => customItemRender(originNode, file, fileList, 'other')}
								fileList={otherFileList}
								multiple={true}
								beforeUpload={(file, fileList) => {
									const filename = file.name.split('.');
									const fileFormat = filename[filename.length - 1];
									// Check if the file size
									if (file.size > AssetHelper.getMaxSize()) {
										messageApi.open({
											type: 'error',
											content: `${file.name} ${AssetHelper.getMaxSizeMsg()}`,
											duration: 2.5
										});
										file.status = 'error';
										return false;
									}

									const maxNumOfFilesExceeded = !_.isEmpty(otherFileList) ? (otherFileList.length >= 5 || otherFileList.length + fileList.length > 5) : fileList.length > 5;
									if (maxNumOfFilesExceeded) {
										messageApi.open({
											type: 'error',
											content: 'You can only upload up to five files.',
											duration: 2.5
										});
										file.status = 'error';
										return false;
									}

									const index = fileList.findIndex(f => f.uid === file.uid);
									const lastFileSuffix = getLastFileNameSuffix(otherFileList);
									const suffix = lastFileSuffix + index + 1;
									const fileName = personalInfo && displayId ? `${file.name}&dl_file_name=${displayId}_${personalInfo.last_name}_${personalInfo.first_name}_Others${suffix}.${fileFormat || ''}` : file.name;
									const newFile = new File([file], fileName, { type: file.type });
									return newFile;
								}}
								onChange={info => {
									const { status } = info.file;
									const fileName = info.file.name.split('&dl_file_name')[0] || '';
									if (status === 'done') {
										messageApi.open({
											type: 'success',
											content: `${fileName} uploaded successfully.`,
											duration: 2.5
										});
									} else if (status === 'error') {
										messageApi.open({
											type: 'error',
											content: `${fileName} upload failed.`,
											duration: 2.5
										});
									}

									let fileList = [...info.fileList];
									fileList = fileList.map(file => {
										if (file.response) {
											file.url = AssetHelper.getDownloadUrl(file.response.data.asset._id);
											file.asset_id = file.response.data.asset._id;
											file.name = file.response.data.asset.file_name;
											file.dl_file_name = file.response.data.asset.dl_file_name;
										}
										return file;
									});
									setOtherFileList(fileList.filter(file => file.status !== 'error'));
									setIsInitialLoad(false);
								}}
								style={{ width: '100%', padding: 10, marginBottom: 10 }}
							>
								<InboxOutlined style={{ fontSize: '5em', color: colorLink }} />
								<p style={{ margin: 0, fontSize: 14 }}>Click or drag file to this area to upload</p>
								<p style={{ margin: 0, fontSize: 10, color: '#6B6B6B' }}>
									Supports single or bulk upload. (PDF)
								</p>
							</Dragger>
						</div>
					</Item>
					<ButtonGroupComponent
						currentStep={currentStep}
						draftDisabled={draftDisabled}
						saveDisabled={nextDisabled}
						loadingSubmit={loadingSubmit}
						onSave={onNext}
						onPrevious={() => {
							if (!draftDisabled) {
								setConfirmation(true);
							} else {
								history.push(`/application?step=3&application_id=${query.application_id}`);
							}
						}}
					/>
					<Confirmation
						loading={loadingSubmit}
						open={confirmation}
						onCancel={() => setConfirmation(false)}
						onOk={() => {
							draftDisabled === false && formRef.current.submit();
							history.push(`/application?step=3&application_id=${query.application_id}`);
						}}
					>
						<Flex
							vertical
							gap={30}
						>
							<Text>
								Save your changes before going back to the previous step?
							</Text>
						</Flex>
					</Confirmation>
				</Form>
			</Row>
		</div>
	);
};

export default SupportingDocumentsView;
